import { Alert, AlertProps } from '@vtex/shoreline'

export const AlertWithTitle: React.FC<
  {
    title?: string
    description?: string
    variant?: AlertProps['variant']
  } & AlertProps
> = ({ title, description, variant = 'critical', children, ...rest }) => (
  <Alert variant={variant} {...rest}>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {title && <span>{title}</span>}
      {description && <span style={{ fontWeight: 400 }}>{description}</span>}
      {children && children}
    </div>
  </Alert>
)
